var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-picker',{attrs:{"value":_vm.value,"open":_vm.open,"type":"time","format":"HH:mm","value-type":"format","placeholder":"Selecione a hora","lang":_vm.ptBr,"disabled":_vm.disabled,"clearable":false},on:{"update:open":function($event){_vm.open=$event},"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }